import {call, put,takeLatest} from 'redux-saga/effects'
import * as cartService from "../../../services/cartService"
import {
    MERGE_CART,
    MERGE_CART_SUCCESS,
    MERGE_CART_ERROR
}
    from "../../actions/cart";

function* mergeCartSaga(action) {
    try {
        const data=yield call(cartService.MergeCart,action.payload)
        yield put({
            type: MERGE_CART_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: MERGE_CART_ERROR,error: error.data
        });
    }
}


export function* mergeCartSagaWatcher() {
    yield takeLatest(MERGE_CART,mergeCartSaga);
}